import Swiper from 'swiper';

// Swiper Slider on Events
(function ($, Drupal) {
  Drupal.behaviors.eventProgram = {
    attach: function (context, settings) {
      if ($('.js-event-dates .swiper-slide', context).length > 1 && $('.js-event-schedules .swiper-slide', context).length > 1) {
        const eventDatesSlider = new Swiper('.js-event-dates .swiper-container', {
          slidesPerView: 'auto',
          slideToClickedSlide: true,
          speed: 600,
          touchRatio: 0.5,
          // Navigation arrows
          navigation: false,
          roundLengths: true,
          freeMode: true,
          freeModeSticky: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true
        });

        const eventSchedulesSlider = new Swiper('.js-event-schedules', {
          autoHeight: true,
          grabCursor: true,
          slidesPerView: 1,
          // Navigation arrows
          navigation: false,
          thumbs: {
            swiper: eventDatesSlider,
          }
        });
      }
      else {
        $('.js-event-dates .swiper-slide', context).addClass('swiper-slide-thumb-active');
      }
    }
  };
})(jQuery, Drupal);
